const NoData: React.FC = () => {
  return (
    <div className="text-center text-accent">
      <h2>Нет данных</h2>
    </div>
  );
};

export default NoData;
